import React, { FC, memo } from 'react';
import { WarehouseForBooking } from 'entities/Warehouse';
import { useMapProvider } from 'app/providers/MapProvider';
import { SelectWarehouseMap } from 'widgets/SelectWarehouseMap';
import { SelectWarehouseMapYandex } from 'widgets/SelectWarehouseMapYandex';

interface SelectWarehouseMapUnifiedProps {
  onCompleteStep: (warehouse: WarehouseForBooking) => void;
}

export const SelectWarehouseMapUnified: FC<SelectWarehouseMapUnifiedProps> = memo((props) => {
  const { onCompleteStep } = props;
  const { mapProvider } = useMapProvider();

  if (mapProvider === 'yandex') {
    return <SelectWarehouseMapYandex onCompleteStep={onCompleteStep} />;
  }

  return <SelectWarehouseMap onCompleteStep={onCompleteStep} />;
});
